import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';

// Menu
export interface MenuSeller {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: MenuSeller[];
}

@Injectable({
	providedIn: 'root'
})

export class NavSellerService {

	public screenWidth: any
	public collapseSidebar: boolean = false
	public fullScreen = false;

	constructor() {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?:any) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: MenuSeller[] = [
		{
			title: 'Dashboard', icon: 'home', type: 'link', badgeType: 'primary',path: '/master/ViewProduct', active: true, 
		},
		{
			title: 'Orders', icon: 'tag', type: 'sub', badgeType: 'primary', active: false, children: [
				{ path: '/master/PendingOrders', title: 'Pending Orders', type: 'link' },
				{ path: '/master/DespatchOrders', title: 'Despatch Orders', type: 'link' },
				{ path: '/master/CancelOrders', title: 'Cancel Orders', type: 'link' },				
			]
		},
		/*{
			title: 'Settings', icon: 'settings', type: 'sub', badgeType: 'primary', active: false, children: [
				{ path: '/master/ViewManufacturer', title: 'Manufacturer', type: 'link' },					
			]
		},*/
		{
			title: 'Logout', icon: 'log-out', type: 'link', badgeType: 'primary',path: '/dashboard/Logout', active: false
		}		
	]
	// Array
	items = new BehaviorSubject<MenuSeller[]>(this.MENUITEMS);


}
